import React, { useEffect, useState } from "react";
import styles from "./agreementSection.scss";
import ShareInformationCheckbox from "./ShareInformationCheckbox";
import ReadPrivacyPolicyCheckbox from "./ReadPrivacyPolicyCheckbox";
import AgreeTermsAndConditionsOfUseCheckbox from "./AgreeTermsAndConditionsOfUseCheckbox";

function AgreementSection(props: any) {
  const [state, setState] = useState({
    isAgreeSharedInformation: false,
    isReadPrivacyPolicy: false,
    isAgreeTermsAndConditionsOfUse: false
  });

  const {
    isAgreeSharedInformation,
    isReadPrivacyPolicy,
    isAgreeTermsAndConditionsOfUse
  } = state;

  useEffect(() => {
    const { onChange } = props;
    const allChecked =
      isAgreeSharedInformation &&
      isReadPrivacyPolicy &&
      isAgreeTermsAndConditionsOfUse;
    onChange(allChecked);
  }, [
    isAgreeSharedInformation,
    isReadPrivacyPolicy,
    isAgreeTermsAndConditionsOfUse
  ]);

  const handleCheckboxChange = (e: any) => {
    const { name, checked } = e.target;

    setState(prevState => ({
      ...prevState,
      [name]: checked
    }));
  };

  return (
    <div className={styles.container}>
      <ShareInformationCheckbox
        isChecked={isAgreeSharedInformation}
        onChange={handleCheckboxChange}
      />
      <ReadPrivacyPolicyCheckbox
        onChange={handleCheckboxChange}
        isChecked={isReadPrivacyPolicy}
      />
      <AgreeTermsAndConditionsOfUseCheckbox
        onChange={handleCheckboxChange}
        isChecked={isAgreeTermsAndConditionsOfUse}
      />
    </div>
  );
}

export default AgreementSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/index.tsx